import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import RoundIconBackground from '../../../RoundIconBackground/RoundIconBackground';
import { roundIconBgTypes } from '../../../../constants/common';
import { ReactComponent as DropCallIcon } from '../../../../../../resource/DropCallIcon.svg';
import {
  setCallDirection,
  setPhoneFieldValue,
} from '../../../../store/actions';
import useSipStates from '../../../../../../hooks/useSipStates';
import { SipPhoneContext } from '../../../../../../components/SipPhoneProvider';

const DropCall = () => {
  const { stopCall } = useContext(SipPhoneContext);

  const dispatch = useDispatch();

  const { isConnected, isIdle } = useSipStates();

  const handleClick = () => {
    stopCall();
    dispatch(setCallDirection(null));
    dispatch(setPhoneFieldValue(''));
  };

  const disabled = !isConnected || isIdle;

  return (
    <RoundIconBackground
      onClick={handleClick}
      containerType={
        disabled ? roundIconBgTypes.disconnected : roundIconBgTypes.drop
      }
      renderIcon={({ className }) => <DropCallIcon className={className} />}
      disabled={disabled}
    />
  );
};

export default DropCall;
